import InputType from "common/form/InputType";
import { Form, Input } from "decorator-form";

@Form({title: "Program Tracks Panel Config"})
export default class Config {


	@Input({type: InputType.TEXT, title: "Widget Title"})
	public title: string;

	/**
	 * tracks
	 */

	@Input({type: InputType.CHECKBOX, title: "Show Progress Bar"})
	public showProgress: boolean;

	@Input({type: InputType.CHECKBOX, title: "Show Track Descriptions"})
	public showDescription: boolean;

	@Input({type: InputType.CHECKBOX, title: "Show Course Count"})
	public showEntryCount: boolean;

	/**
	 * track products
	 */

	 @Input({type: InputType.CHECKBOX, title: "Show Track Products as Thumbnail Cards"})
	 public isCardThumbnail: boolean;

	 @Input({type: InputType.CHECKBOX, title: "Show Track Product Progress"})
	 public showCourseProgress: boolean;

}



// WEBPACK FOOTER //
// ./src/panels/tracksProgram/Config.ts